module.exports = __webpack_public_path__ + "img/header.5a9e3355.png";